import { render } from "./The404Page.vue?vue&type=template&id=fd4bfee4&scoped=true"
import script from "./The404Page.vue?vue&type=script&lang=js"
export * from "./The404Page.vue?vue&type=script&lang=js"

import "./The404Page.vue?vue&type=style&index=0&id=fd4bfee4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd4bfee4"]])

export default __exports__